import { render } from "./RestyleInput.vue?vue&type=template&id=4df7a6fb&scoped=true"
import script from "./RestyleInput.vue?vue&type=script&lang=js"
export * from "./RestyleInput.vue?vue&type=script&lang=js"

import "./RestyleInput.vue?vue&type=style&index=0&id=4df7a6fb&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4df7a6fb"]])

export default __exports__